const format = (value: any) => {
  return value
}

const ratingField = {
  format,
}

export default ratingField
